/**
 * EditableTimeCell - Component for adding/reducing time for students
 * Adapted from old LiveDashboard EditableCell
 */
import React, { useState, useCallback, memo } from 'react'
import { Button, Form } from 'react-bootstrap'
import log from 'loglevel'
import httpService from 'services/httpService'
import * as constants from 'Constants'
import displayGlobalMessage from 'Utils/DisplayGlobalMessage'
import styles from '../../LabsV2.module.css'

const EditableTimeCell = ({
  modifyAll = false,
  studentId,
  examId,
  onSuccess
}) => {
  const [isEditing, setIsEditing] = useState(false)
  const [value, setValue] = useState(0)

  const handleEdit = () => setIsEditing(true)

  const handleClose = () => {
    setIsEditing(false)
    setValue(0)
  }

  const modifyTime = useCallback(async (timeDelta) => {
    try {
      if (timeDelta === 0) {
        displayGlobalMessage('Please enter a valid time', 'error')
        return
      }

      if (modifyAll) {
        await httpService.put(
          `${constants.base_url}/exam/${examId}/proctor/modifytime/all`,
          { time_delta: timeDelta }
        )
        displayGlobalMessage('Time updated successfully!', 'success')
      } else {
        await httpService.put(
          `${constants.base_url}/exam/${examId}/proctor/modifytime/${studentId}`,
          { time_delta: timeDelta }
        )
        displayGlobalMessage('Time updated successfully', 'success')
      }

      handleClose()
      onSuccess?.()
    } catch (error) {
      if (error.response && error.response.status === 403) {
        if (error.response.data?.error) {
          displayGlobalMessage(error.response.data.error, 'error')
        } else {
          displayGlobalMessage("Exam has ended, Can't add time now", 'error')
        }
      } else {
        log.error(error)
        displayGlobalMessage('An error occurred while modifying time', 'error')
      }
    }
  }, [modifyAll, studentId, examId, onSuccess])

  const handleAdd = () => modifyTime(value)
  const handleReduce = () => modifyTime(-1 * value)

  if (isEditing) {
    return (
      <div className={styles.editableTimeContainer}>
        <div className={styles.editableTimeInputRow}>
          <Form.Control
            type="number"
            value={value}
            onChange={(e) => setValue(Number(e.target.value))}
            className={styles.editableTimeInput}
            min="0"
            placeholder="Minutes"
          />
          <Button
            variant="light"
            size="sm"
            onClick={handleClose}
            className={styles.editableTimeCloseBtn}
          >
            &times;
          </Button>
        </div>
        <div className={styles.editableTimeButtonRow}>
          <Button
            variant="primary"
            size="sm"
            onClick={handleAdd}
            className={styles.editableTimeBtn}
          >
            Add
          </Button>
          <Button
            variant="secondary"
            size="sm"
            onClick={handleReduce}
            className={styles.editableTimeBtn}
          >
            Reduce
          </Button>
        </div>
      </div>
    )
  }

  return (
    <span
      className={styles.editableTimeLink}
      onClick={handleEdit}
    >
      {value}
    </span>
  )
}

export default memo(EditableTimeCell)
